// this is an autogenerated file from App/Account/Content/Settings/Content/NoteTemplates/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_NoteTemplates($id: uuid!) {
  notes_templates_by_pk(id: $id) {
    id
    name
    tags
    url
  }
}

`